import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../context/Auth';

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  const { authToken } = useAuth();
  return (
    <Route
      {...rest}
      render={props =>
        authToken ? <Component {...props} /> : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      }
    />
  );
};

export default PrivateRoute;
